import api from "@/modules/sync/services/api";
import _ from "lodash";

export default {
  namespaced: true,
  actions: {
    rerun({ commit }, payload) {
      return api.rerun(payload).then((response) => response.data);
    },
  },
};
